module.exports = __webpack_public_path__ + "static/media/back-mobile.6345875e.png";